import { render, staticRenderFns } from "./Apks.vue?vue&type=template&id=4b77022c&scoped=true&"
import script from "./Apks.vue?vue&type=script&lang=js&"
export * from "./Apks.vue?vue&type=script&lang=js&"
import style0 from "./Apks.vue?vue&type=style&index=0&id=4b77022c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b77022c",
  null
  
)

export default component.exports